module.exports = __webpack_public_path__ + "static/media/8604-f-l-en.aea9f653.png";